export default {"src":"/_next/static/media/0x5d9ab5522c64e1f6ef5e3627eccc093f56167818.cf54c71c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};